import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=343cc3ae&scoped=true&"
import script from "./gallery.vue?vue&type=script&lang=ts&"
export * from "./gallery.vue?vue&type=script&lang=ts&"
import style0 from "./gallery.vue?vue&type=style&index=0&id=343cc3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343cc3ae",
  null
  
)

export default component.exports